<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .experience-wrapper {
    display: flex;
    gap: utils.in_rem(12px);
    width: 100%;

    .experience-item {
      display: flex;
      flex: 1;
      flex-direction: column;
      gap: utils.in_rem(6px);

      .header {
        display: flex;
        flex-direction: column;

        .title-row {
          display: flex;
          gap: utils.in_rem(8px);
          align-items: center;

          .role {
            @include mixins.h5;
            @include colors.color(primary_90);
            overflow-wrap: break-word;
            word-wrap: break-word;
          }

          .duration {
            @include mixins.body3;
            @include colors.color(black_50);
            overflow-wrap: break-word;
            word-wrap: break-word;
          }
        }

        .company {
          @include mixins.body3;
          @include colors.color(black_90);
          overflow-wrap: break-word;
          word-wrap: break-word;

          a {
            @include colors.color(primary_50);
            text-decoration: none;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }

      .description-list {
        display: flex;
        flex-direction: column;
        gap: utils.in_rem(4px);

        .description-item {
          @include mixins.body4-tooltip;
          @include colors.color(black_50);
          overflow-wrap: break-word;
          word-wrap: break-word;
          max-width: 90%;
        }
      }
    }
  }
</style>

<script>
  import { formatDate } from "./utils.js";

  let { experience } = $props();

  let startDate = $derived(formatDate(experience.startedAt));
  let endDate = $derived(formatDate(experience.endedAt, "Present"));
  let duration = $derived(
    startDate && endDate ? `${startDate} - ${endDate}` : ""
  );

  let itemsToDisplay = $derived(
    [experience.location, experience.description].filter(Boolean)
  );

  const getLinesFromItem = (item) =>
    item.split(/\s+-\s+/).flatMap((part) =>
      part
        .split("\n")
        .map((line) => line.trim().replace(/^-\s*/, ""))
        .filter((line) => line.length)
    );

  let descriptionItems = $derived(
    (itemsToDisplay ?? []).flatMap(getLinesFromItem)
  );
</script>

<div class="experience-wrapper">
  <div class="experience-item">
    <div class="header">
      <div class="title-row">
        {#if experience.role}
          <div class="role">{experience.role}</div>
        {/if}
        {#if duration}
          <div class="duration">{duration}</div>
        {/if}
      </div>
      {#if experience.company && experience.companyLinkedinUrl}
        <div class="company">
          <a href="https://{experience.companyLinkedinUrl}" target="_blank">
            {experience.company}
          </a>
        </div>
      {:else if experience.company}
        <div class="company">{experience.company}</div>
      {/if}
    </div>
    {#if descriptionItems.length}
      <div class="description-list">
        {#each descriptionItems as item}
          <div class="description-item">{item}</div>
        {/each}
      </div>
    {/if}
  </div>
</div>
